// @generated by protoc-gen-grpc-gateway-es v0.5.0 with parameter "target=ts,generate_name_parser=true"
// @generated from file aiem/aiem.proto (package aiem, syntax proto3)
/* eslint-disable */

import { RPC } from "../runtime";

/**
 * @generated from message aiem.AiemEventsRequest
 */
export type AiemEventsRequest = {
/**
 * RFC3339 format with timezone (e.g., "2025-01-01T00:00:00-05:00")
 *
 * @generated from field: string start_date = 1;
 */
startDate?: string;
/**
 * RFC3339 format with timezone (e.g., "2025-01-31T23:59:59-05:00")
 *
 * @generated from field: string end_date = 2;
 */
endDate?: string;
/**
 * @generated from field: aiem.UserContext user_context = 3;
 */
userContext?: UserContext;
}
;
/**
 * @generated from message aiem.AiemEventsResponse
 */
export type AiemEventsResponse = {
/**
 * @generated from field: repeated aiem.AiemEvent events = 1;
 */
events?: AiemEvent[];
}
;
/**
 * @generated from message aiem.AiemEvent
 */
export type AiemEvent = {
/**
 * Timestamp
 *
 * @generated from field: string ts = 1;
 */
ts?: string;
/**
 * Stream
 *
 * @generated from field: string stream = 2;
 */
stream?: string;
/**
 * User name
 *
 * @generated from field: string user_name = 3;
 */
userName?: string;
/**
 * Engine Name
 *
 * @generated from field: string engineName = 4;
 */
engineName?: string;
/**
 * Engine Type
 *
 * @generated from field: string type = 5;
 */
type?: string;
/**
 * Version
 *
 * @generated from field: string version = 6;
 */
version?: string;
/**
 * CPU count
 *
 * @generated from field: int32 cpu = 7;
 */
cpu?: number;
/**
 * Memory count
 *
 * @generated from field: int32 memory = 8;
 */
memory?: number;
/**
 * GPU count
 *
 * @generated from field: int32 gpu = 9;
 */
gpu?: number;
/**
 * Storage value
 *
 * @generated from field: int32 storage = 10;
 */
storage?: number;
/**
 * AI unit count
 *
 * @generated from field: float ai_units = 11;
 */
aiUnits?: number;
}
;
/**
 * @generated from message aiem.UserContext
 */
export type UserContext = {
/**
 * @generated from field: string user_email = 1;
 */
userEmail?: string;
/**
 * @generated from field: string source_ip_address = 2;
 */
sourceIpAddress?: string;
/**
 * @generated from field: string user_agent = 3;
 */
userAgent?: string;
}
;
/**
 * @generated from rpc aiem.AiemService.GetAiemEvents
 */
export const AiemService_GetAiemEvents = new RPC<AiemEventsRequest,AiemEventsResponse>("POST", "/getAiemEvents");
